import React from 'react'
import CardSection from '../cardSection'

export default function AnchorePool() {
    return (
        <CardSection role='anchorpool' section='06' sectionTitle='Anchors—A go-to friend for Buddha Fellows' />
    )
}
